export default __webpack_public_path__ + "static/media/icon-logo.3d7fb7d9.svg";